/**
 * Browser-native replacement for Node's crypto.randomBytes(n) .
 * Uses the Web Crypto API (globalThis.crypto) available in all modern browsers
 * and Node.js 19+. Produces an identical output: 2n hex characters from n random bytes.
 */
export function randomHex(bytes = 12): string {
  return Array.from(globalThis.crypto.getRandomValues(new Uint8Array(bytes)))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export const randomBytes = (n: number): string => randomHex(n);

const crypto = { randomBytes };

export default crypto;